export const SUPPORTED_LOCALES = ["en", "de", "es", "fr", "pt", "zh"] as const

export type SupportedLocale = (typeof SUPPORTED_LOCALES)[number]

// `satisfies` over a `: SupportedLocale` annotation so the literal type survives:
// an annotation widens this to the full union, which silently turns type-level
// uses like `Exclude<SupportedLocale, typeof DEFAULT_LOCALE>` into `never`.
export const DEFAULT_LOCALE = "en" satisfies SupportedLocale

// Endonyms: each language is labelled in its own language so a speaker can find
// their language regardless of the current UI locale. Like brand names, these
// are intentionally NOT routed through `t()` — translating them would defeat a
// language picker (a French speaker still needs to recognise "中文").
export const LOCALE_LABELS: Record<SupportedLocale, string> = {
  en: "English",
  de: "Deutsch",
  es: "Español",
  fr: "Français",
  pt: "Português",
  zh: "中文",
}

export const isSupportedLocale = (
  value: string | undefined | null,
): value is SupportedLocale =>
  value != null && (SUPPORTED_LOCALES as readonly string[]).includes(value)
